import { api, throwApiError } from "../../api/api";

export type UserType = "ADMIN" | "SUPERVISOR" | string;

export type UserListItem = {
  id: string;
  nomeCompleto: string;
  cpf: string;
  email: string;
  userType: UserType;
  storeIds: string[];
  createdAt: string;
  updatedAt?: string | null;
};

export type PaginatedUsersResponse = {
  items: UserListItem[];
  page: number;
  limit: number;
  total: number;
};

export const getUsersPaginatedApi = async (
  page = 1,
  limit = 10,
  status?: "active" | "deleted" | "all"
): Promise<PaginatedUsersResponse> => {
  try {
    const { data } = await api.get<PaginatedUsersResponse>("/users", {
      params: { page, limit, ...(status ? { status } : {}) },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar usuários.");
    throw error;
  }
};
